module.exports = __webpack_public_path__ + "img/alert-circle.78da5dcf.svg";